import defaultsDeep from 'lodash/defaultsDeep'

const primary = {
  main: '#000000',
  dark: '#000000',
  light: '#333333',
  contrastText: '#FFFFFF',
}

const secondary = {
  main: '#DB238A',
  dark: '#A71B68',
  light: '#E75AA8',
  contrastText: '#FFFFFF',
}

const success = {
  main: '#6c9416',
  dark: '#4a660f',
  light: '#8bbf1c',
  contrastText: '#FFFFFF',
}

const info = {
  main: '#1f8ec6',
  dark: '#155f84',
  light: '#3da9e1',
  contrastText: '#FFFFFF',
}

const warning = {
  main: '#f3c802',
  dark: '#816A01',
  light: '#fddc44',
  contrastText: '#FFFFFF',
}

const error = {
  main: '#DB238A',
  dark: '#A71B68',
  light: '#E75AA8',
  contrastText: '#FFFFFF',
}

const text = {
  primary: 'rgba(0, 0, 0, 0.72)',
  secondary: 'rgba(0, 0, 0, 0.62)',
  disabled: 'rgba(0, 0, 0, 0.3)',
  contrast: '#FFFFFF',
}

const brand = {
  blue: '#253a7a',
  cyan: '#45baeb',
  lime: '#8ac541',
  purple: '#6a439a',
  magenta: '#DB238A',
  orange: '#f78f20',
  yellow: '#fbdc0d',
  grey: '#636569',
  black: '#000000',
}

const background = {
  default: '#FFFFFF',
  paper: '#FFFFFF',
  backdrop: 'rgba(255, 255, 255, 0.7)',
}

const action = {
  active: 'rgba(0, 0, 0, 0.54)',
  selected: 'rgba(0, 0, 0, 0.08)',
  hover: 'rgba(0, 0, 0, 0.04)',
  disabled: 'rgba(0, 0, 0, 0.26)',
  disabledBackground: 'rgba(0, 0, 0, 0.12)',
  focus: 'rgba(0, 0, 0, 0.12)',
}

const divider = 'rgba(0, 0, 0, 0.12)'

const defaultPalette = {
  primary,
  secondary,
  success,
  info,
  warning,
  error,
  text,
  brand,
  background,
  action,
  divider,
}

export const lightTheme = ({ palette } = {}) => {
  // Merge the provided palette with the default one to ensure all values are present
  const newPalette = defaultsDeep({ mode: 'light' }, palette, defaultPalette)
  const { secondary, text, background } = newPalette

  return {
    palette: newPalette,
    components: {
      MuiButton: {
        variants: [
          {
            props: { variant: 'contained', color: 'primary' },
            style: {
              '&:hover:not(.Mui-disabled):not(.MuiLoadingButton-loading)': {
                backgroundColor: secondary.main,
              },
            },
          },
          {
            props: { variant: 'contained', color: 'secondary' },
            style: {
              '&:hover:not(.Mui-disabled):not(.MuiLoadingButton-loading)': {
                outline: `2px solid ${secondary.main}`,
                backgroundColor: secondary.contrastText,
                color: secondary.main,
              },
            },
          },
        ],
      },
      MuiInputBase: {
        styleOverrides: {
          root: {
            backgroundColor: background.paper,
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: '12px',
          },
        },
      },
      MuiPickersOutlinedInput: {
        styleOverrides: {
          root: {
            backgroundColor: background.paper,
            borderRadius: '12px',
          },
        },
      },
      MuiListSubheader: {
        styleOverrides: {
          root: {
            color: text.primary,
          },
        },
      },
      MuiBackdrop: {
        styleOverrides: {
          root: {
            '&:not(.MuiBackdrop-invisible)': {
              backgroundColor: background.backdrop,
              backdropFilter: 'blur(4px)',
            },
          },
        },
      },
      MuiLink: {
        styleOverrides: {
          root: {
            color: secondary.main,
            '&:hover': {
              color: secondary.dark,
            },
          },
        },
      },
    },
  }
}
